<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Rutas</ion-title>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="backUrl" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar *ngIf="transportec">
    <ion-segment mode="md" [(ngModel)]="show">
      <ion-segment-button value="go">
        <ion-label>LLEGADA</ion-label>
      </ion-segment-button>
      <ion-segment-button value="return">
        <ion-label>SALIDA</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content #container class="ion-padding">
  <div *ngIf="!routes && loadingRoutes">
    <div class="ride" *ngFor="let route of [0,1,2,3,4,5]">
      <ion-avatar class="photo avatar">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
      <div class="description">
        <div class="text">
          <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
        </div>
      </div>
    </div>
  </div>

  <div [class]="'ride ' + route.type" *ngFor="let route of routes | callback: filterReturn" [hidden]="show==='go'">
    <ion-img class="photo" [src]="route.icon" *ngIf="route.icon"></ion-img>
    <ion-img class="photo" [src]="route.image" *ngIf="!route.icon && route.image"></ion-img>
    <div class="description">
      <div class="text">
        <h4>{{route.name}}</h4>
        <p>{{route.description}}</p>
        <p>Paradas: {{route.stops.length}}</p>
      </div>
    </div>
    <div class="fab-container">
      <ion-fab-button color="primary" size="small" (click)="goRouteMap(route)">
        <ion-icon src="/assets/icon/paradas.svg"></ion-icon>
      </ion-fab-button>
      <ion-label>Mapa</ion-label>
    </div>
    <div class="fab-container2">
      <ion-fab-button color="primary" size="small" (click)="goRoute(route)">
        <ion-icon src="/assets/icon/lista-paradas.svg"></ion-icon>
      </ion-fab-button>
      <ion-label>Paradas</ion-label>
    </div>
  </div>

  <div [class]="'ride ' + route.type" *ngFor="let route of routes | callback: filterGo" [hidden]="show==='return'">
    <ion-img class="photo" [src]="route.icon" *ngIf="route.icon"></ion-img>
    <ion-img class="photo" [src]="route.image" *ngIf="!route.icon && route.image"></ion-img>
    <div class="description">
      <div class="text">
        <h4>{{route.name}}</h4>
        <p>{{route.description}}</p>
        <p>Paradas: {{route.stops.length}}</p>
      </div>
    </div>
    <div class="fab-container">
      <ion-fab-button color="primary" size="small" (click)="goRouteMap(route)">
        <ion-icon src="/assets/icon/paradas.svg"></ion-icon>
      </ion-fab-button>
      <ion-label>Mapa</ion-label>
    </div>
    <div class="fab-container2">
      <ion-fab-button color="primary" size="small" (click)="goRoute(route)">
        <ion-icon src="/assets/icon/lista-paradas.svg"></ion-icon>
      </ion-fab-button>
      <ion-label>Paradas</ion-label>
    </div>
  </div>
</ion-content>
